import { Configuration, ExpitecApi } from '../../bewotec/openapi'
import { STAGE, URLs } from '../../general/helper'
import { IUrls } from '../../general/interfaces'

export const bewotecMicroServiceApi = () => {
  const configuration = new Configuration({
    basePath: URLs[STAGE as keyof IUrls].bewotec,
    apiKey: URLs[STAGE as keyof IUrls].bewotecApiKey,
  })
  
  return new ExpitecApi(configuration)
}

// map AIDA agency ids to 30449 to allow requests
// agency id must be registered with Bewotec Services and must be a number
export const mapAgencyForRequest = (agencyId: string) => {
  switch (agencyId) {
    case 'AIDA':
    case 'AIDA AKC':
    case 'AIDASEE':
      return 30449
    default:
      return parseInt(agencyId, 10)
  }
}

export const appHelper = {
  bewotecMicroServiceApi,
}